import { render, staticRenderFns } from "./PayableAmounts.vue?vue&type=template&id=551554fc"
import script from "./PayableAmounts.vue?vue&type=script&lang=js"
export * from "./PayableAmounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports